require('./style.less');

var Marionette = require('marionette'),
    NoteTypeSelectView = require('../noteTypeSelect/view'),
    NoteLevelPropertiesView = require('../notePropertyViews/view');


module.exports = Marionette.LayoutView.extend({

    initialize: function( options ) {

        this.channel = options.channel;
        this.searchModel = options.model;
        this.disableInputs = options.disableInputs ? true : false;
        this.parentForm = options.parentForm;
        this.focusInputOnShow = options.focusInputOnShow;

    },

    template: require('./template.hbs'),

    ui: {
        searchInput:        '.fr-search-input'
    },

    regions: {
        noteTypeSelectRegion:       '.fr-note-type-select-region',
        noteLevelPropertiesRegion:  '.fr-search-note-properties-region'
    },

    serializeData: function() {

        var searchTerm = this.searchModel.get('searchTerm');

        return {
            searchTerm: searchTerm === null ? '' : searchTerm,
            disableSearch: this.disableInputs
        };

    },

    events: {
        'input @ui.searchInput':    'searchInputChange'
    },

    onShow: function() {

        if ( this.focusInputOnShow ) {

            setTimeout( function() {
                this.ui.searchInput.focus();
            }.bind(this), 0 );

        }

    },

    /**
     * Create child view onRender, not onBeforeShow due to bug in this version of Marionette
     */
    onRender: function() {

        /* perhaps combine? */
        this._showNoteTypeSelectView();
        this._showNoteLevelPropertiesView();

    },

    /* Issue -- don't want to re-render when already focused in this input field -- toggle appropriate I think */
    /* Better way to stop it -- just send an event */
    searchInputChange: function(e) {

        e.stopPropagation(); // (Mousetrap - hotkeys )
        this.searchModel.setSearchTerms( $(e.target).val() );

        this.parentForm && this.parentForm.toggleSubmitBtnEnabled();

    },

    _showNoteTypeSelectView: function() {

        this.noteTypeSelectRegion.show( new NoteTypeSelectView({
            channel: this.channel,
            noteTypeGroup: this.searchModel.getNoteModel().getNoteTypeGroup(),
            renderDisabled: this.disableInputs,

            onChange: function( noteType ) {


                var newNote = this.channel.request( 'getNewNoteModel', noteType );

                // TODO --  any cleanup here -- if edit likely ...
                this.searchModel.setNoteModel( newNote );

                this._showNoteLevelPropertiesView();

            }.bind( this )

        }));

    },

    _showNoteLevelPropertiesView: function() {


        this.noteLevelPropertiesRegion.show( new NoteLevelPropertiesView({
            channel: this.channel,
            model: this.searchModel.getNoteModel(),
            disableInputs: this.disableInputs
        }));

    }




});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/findAndRedact/layout/searchModelView/view.js
 ** module id = 593
 ** module chunks = 0
 **/